import _ from "lodash";
import React, { forwardRef, useState } from "react";
import { FieldTypes } from "utils/formUtils";

import GenericMappingForm from "../GenericMappingForm";

const initialFormValues = {
  product: undefined,
  subProduct: undefined,
  environment: undefined,
};

const AxoniusMappingForm = forwardRef(function AxoniusMappingForm(props, ref) {
  const [initialValues] = useState(() => {
    if (props.record) {
      return [];
    }
    return [{ ...initialFormValues, assetType: "devices" }];
  });

  const extraFields = [
    {
      name: "assetType",
      label: "Asset Types",
      type: FieldTypes.SELECT,
      colSpan: 12,
      options: [
        { label: "Devices", value: "devices" },
        { label: "Domains & URLs", value: "domainsAndUrls" },
      ],
    },
  ];

  const getExtraFieldsData = (config) => {
    const { assetType } = config;
    return {
      assetType,
    };
  };

  return (
    <GenericMappingForm
      ref={ref}
      extraFields={extraFields}
      getExtraFieldsData={getExtraFieldsData}
      formDefaultValues={initialValues}
      {...props}
    />
  );
});

export default AxoniusMappingForm;
